module.exports = __webpack_public_path__ + "img/standards-icon-d.bd95f1b.png";